import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ShoppingCart,
  Package,
  UserPlus,
  Users,
  FileText,
  Grid,
  DollarSign,
  Layers,
  Search,
  List,
  BarChart
} from 'lucide-react';

const iconMap = {
  ShoppingCart,
  Package,
  UserPlus,
  Users,
  FileText,
  Grid,
  DollarSign,
  Layers,
  Search,
  List,
  BarChart
};

const QuickActions = ({ actions = [], loading = false }) => {
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="bg-theme-secondary rounded-lg shadow-theme-md p-4 md:p-6 border border-theme">
        <div className="h-5 w-32 bg-theme-tertiary rounded mb-4 animate-pulse"></div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-24 bg-theme-tertiary rounded-lg animate-pulse"></div>
          ))}
        </div>
      </div>
    );
  }

  const handleActionClick = (route) => {
    if (route) {
      navigate(route);
    }
  };

  return (
    <div className="bg-theme-secondary rounded-lg shadow-theme-md p-4 md:p-6 border border-theme">
      <h2 className="text-lg md:text-xl font-bold text-theme-primary mb-4">Quick Actions</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
        {actions.map((action) => {
          const IconComponent = iconMap[action.icon] || Package;
          const isGold = action.color === 'gold';

          return (
            <button
              key={action.id}
              onClick={() => handleActionClick(action.route)}
              className={`p-3 md:p-4 border-2 rounded-lg text-left transition-all hover:shadow-theme-md group ${
                isGold
                  ? 'border-accent-gold bg-accent-gold/10 hover:bg-accent-gold/15'
                  : 'border-theme hover:border-accent-gold hover:bg-gray-100 dark:hover:bg-gray-800/50'
              }`}
            >
              <div className="text-accent-gold text-2xl mb-2 relative z-10">
                <IconComponent className="w-6 h-6 transition-transform group-hover:scale-110" />
              </div>
              <h3 className="font-semibold text-theme-primary text-sm md:text-base">
                {action.label}
              </h3>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default QuickActions;
